<template>
  <page-view>
    <lead-news-container :news="news"/>
    <artworks-section/>
    <secondary-news-container :news="newsSec"/>
  </page-view>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import LeadNewsContainer from '@/containers/Home/LeadNewsContainer'
import SecondaryNewsContainer from '@/containers/Home/SecondaryNewsContainer'
import ArtworksSection from '@/containers/Home/ArtworksSection'

export default {
  components: {
    LeadNewsContainer,
    SecondaryNewsContainer,
    ArtworksSection
  },
  computed: {
    ...mapGetters(['news', 'newsSec'])
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('fetchNews')
      .then(next)
      .catch(() => {
        // next({ name: 'home' })
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Home/HomeContainer.vue